import type { ElementType } from "react";
import {
  StickyNote, Calendar, TrendingUp, Network, Paperclip, Mail, UserPlus,
} from "lucide-react";
import { EngagementPeriod, type EngagementEventType } from "@/types/engagement";

export { EngagementPeriod };

export const PAGE_SIZE = 20;

export const PERIODS: { key: EngagementPeriod; label: string }[] = [
  { key: EngagementPeriod.OneWeek, label: "1W" },
  { key: EngagementPeriod.OneMonth, label: "1M" },
  { key: EngagementPeriod.ThreeMonths, label: "3M" },
  { key: EngagementPeriod.SixMonths, label: "6M" },
  { key: EngagementPeriod.OneYear, label: "1Y" },
];

export const TYPE_FILTER_PILLS: { key: EngagementEventType; label: string }[] = [
  { key: "activity",    label: "Activities" },
  { key: "document",    label: "Documents" },
  { key: "email",       label: "Emails" },
  { key: "note",        label: "Notes" },
  { key: "opportunity", label: "Opportunities" },
  { key: "project",     label: "Projects" },
  { key: "prospect",    label: "Prospects" },
];

export const TYPE_CONFIG: Record<EngagementEventType, { icon: ElementType; label: string; color: string; backgroundColor?: string }> = {
  note:        { icon: StickyNote,  label: "Note",        color: "#8b5cf6" },
  activity:    { icon: Calendar,    label: "Activity",    color: "#10b981" },
  opportunity: { icon: TrendingUp,  label: "Opportunity", color: "#3b82f6" },
  project:     { icon: Network,     label: "Project",     color: "#f59e0b" },
  document:    { icon: Paperclip,   label: "Document",    color: "#6b7280" },
  email:       { icon: Mail,        label: "Email",       color: "var(--color-sky-600)", backgroundColor: "var(--color-sky-50)" },
  prospect:    { icon: UserPlus,    label: "Prospect",    color: "#ec4899" },
};
